import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import SubCategoryFormModal from './InformationFormModal';

const EditSubCategoryButton = ({
  subCategory, updateInformation, deleteInformation, categoryId, categoryTitle
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState(false);

  const showModal = async () => {
    setModalVisible(true);
  };
  const hideModal = () => {
    setModalVisible(false);
  };
  const onSubmit = async (data) => {
    hideModal();
    await updateInformation({
      id: subCategory.id,
      destination_id: categoryId,
      payload: { tour_information: { ...data, destination_id: categoryId } },
    });
  };
  const renderContent = () => {
    return (
      <div style={{ paddingTop: 12, paddingBottom: 30 }}>This action will delete the Remove Information({subCategory.title}) permanently. Are you sure?</div>
    )
  };

  const confirmDelete = () => {
    Modal.confirm({
      title: `Remove Information`,
      icon: '',
      content: renderContent(),
      closable: true,
      okText: `REMOVE`,
      onOk() {
        deleteInformation({
          id: subCategory.id,
          destination_id: categoryId
        });
        hideModal();
      },
      cancelButtonProps: { style: { display: 'none' } }
    });
  };
  const footer = (
    <Button
      icon={<DeleteOutlined />}
      onClick={confirmDelete}
      danger
    >
      Delete
    </Button>
  );

  useEffect(() => {
    setFormData(subCategory);
  }, [modalVisible]);

  return (
    <>
      <SubCategoryFormModal
        onSubmit={onSubmit}
        onCancel={hideModal}
        visible={modalVisible}
        title={`Edit Tour Information`}
        submitText="Update Info"
        data={formData}
        footer={footer}
      />
      <p>{subCategory.title} - {subCategory.subtitle} {' '}<span className={subCategory.status === true ? 'activate' : 'inActivateNotverified'}>{subCategory.status === true ? 'Active' : 'Blocked'}</span> <span onClick={showModal}><EditOutlined /></span></p>
    </>
  );
};
export default EditSubCategoryButton;
